import { FC, useState } from 'react'
import { Tab, Tabs, Typography } from '@mui/material'
import { AssetInventoryType } from 'models'
import { AssetInventoryContainer, HeaderCard, PageHeader, TabBar, TabsPanel } from './assetInventory.styles'
import { ASSET_TABS, LAST_SEEN_LABELS, LAST_SEEN_OPTIONS } from './assetInventory.constants'
import { useLastSeen } from './hooks/useLastSeen'
import { useIntegrationInstances } from './hooks/useIntegrationInstances'
import InlineSelect from './components/InlineSelect'
import AssetTab from './sections/AssetTab'

const AssetInventory: FC = () => {
  const [activeTab, setActiveTab] = useState<AssetInventoryType>(AssetInventoryType.Identities)
  const { lastSeen, setLastSeen } = useLastSeen()
  const instances = useIntegrationInstances()

  return (
    <AssetInventoryContainer>
      <HeaderCard>
        <PageHeader>
          <Typography className="page-title">Asset Inventory</Typography>
          <InlineSelect
            label="Last Seen:"
            ariaLabel="Last seen window"
            value={lastSeen}
            options={LAST_SEEN_OPTIONS}
            optionLabel={(option) => LAST_SEEN_LABELS[option as typeof lastSeen] ?? option}
            onChange={(value) => setLastSeen(value as typeof lastSeen)}
          />
        </PageHeader>

        <TabBar>
          <Tabs
            value={activeTab}
            onChange={(_event, value: AssetInventoryType) => setActiveTab(value)}
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            {ASSET_TABS.map((tab) => (
              <Tab key={tab.assetType} value={tab.assetType} label={tab.label} disableRipple />
            ))}
          </Tabs>
        </TabBar>
      </HeaderCard>

      <TabsPanel>
        {ASSET_TABS.filter((tab) => tab.assetType === activeTab).map((tab) => (
          <AssetTab
            key={tab.assetType}
            config={tab}
            instances={instances}
            lastSeen={lastSeen}
            active
          />
        ))}
      </TabsPanel>
    </AssetInventoryContainer>
  )
}

export default AssetInventory
